export default {
	REGULAR: 'regular',
	TEAMS: 'teams',
	LTI: 'lti',
	EXTENSION: 'extension',
	PUBLIC_LIBRARY: 'PersonalLibrary',
	PRIVATE_LIBRARY: 'PrivateLibrary',
}
